import { render, staticRenderFns } from "./refundsList.vue?vue&type=template&id=35c61bcd&scoped=true&"
import script from "./refundsList.vue?vue&type=script&lang=js&"
export * from "./refundsList.vue?vue&type=script&lang=js&"
import style0 from "./refundsList.vue?vue&type=style&index=0&id=35c61bcd&lang=scss&scoped=true&"
import style1 from "./refundsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c61bcd",
  null
  
)

export default component.exports